import GameParameterInterface from '@/models/game/parameters/interface'

interface GamelessLotteryParameter {
  prize: GamelessPrize
}

interface GamelessPrize {
  prizeImage: string,
}

export default class GamelessParameter implements GameParameterInterface {
  constructor(private parameter: GamelessLotteryParameter) { }

  createSetOption(): GamelessLotteryParameter {
    return {
      prize: this.parameter.prize,
    }
  }

  get guideUrl(): string {
    return ''
  }
}
